const DataMateriDiklat = [
  {
    id: "1",
    namaMateri: "Palang Merah Indonesia",
    deskripsiMateri: "Materi Kepalang Merahan",
    linkMateri: "/doc/Materi_Palang_Merah_Indonesia.pdf",
  },
  {
    id: "2",
    namaMateri: "Pertolongan Pertama",
    deskripsiMateri: "Materi Pertolongan Pertama",
    linkMateri: "/doc/Materi_Palang_Merah_Indonesia.pdf",
  },
  {
    id: "3",
    namaMateri: "Tanggap Bencana",
    deskripsiMateri: "Materi Tanggap Bencana",
    linkMateri: "/doc/Materi_Palang_Merah_Indonesia.pdf",
  },
  {
    id: "4",
    namaMateri: "Forum Relawan",
    deskripsiMateri: "Materi Forum Relawan",
    linkMateri: "/doc/Materi_Palang_Merah_Indonesia.pdf",
  },
  {
    id: "5",
    namaMateri: "Donor Darah",
    deskripsiMateri: "Materi Donor Darah",
    linkMateri: "/doc/Materi_Palang_Merah_Indonesia.pdf",
  },
];

export default DataMateriDiklat